import React from "react";

import { ProjectsCtxMenu } from "./ProjectsCtxMenu";
import { ViewsCtxMenu } from "./ViewsCtxMenu";

export const ContextMenus: React.FC = () => {
	return (
		<>
			<ViewsCtxMenu />
			<ProjectsCtxMenu />
		</>
	);
};
